import { rem } from "@affinity/constants/StyleHelpers";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import React from "react";
import styled from "styled-components";

interface OwnProps {
    product: string;
    amount: string;
    onDismiss: () => void;
    onConfirm: () => void;
}

const TextContainer = styled.div`
    display: flex;
    flex-flow: column nowrap;
    p {
        display: block;
        padding: 0 0 ${rem(20)} 0;
        font-size: ${rem(16)};
        line-height: ${rem(26)};
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    gap: ${rem(24)};
    @media (min-width: ${rem(768)}) {
        justify-content: flex-end;
    }
`;

const ConfirmQuantityForm = ({ product, amount, onDismiss, onConfirm }: OwnProps) => {
    return (
        <>
            <TextContainer>
                <p>{translate("Please confirm you will have adequate capacity for delivery.")}</p>
                <p>{translate("Any excess heating oil that we are unable to deliver will be refunded to you. You will only be charged for what is successfully delivered.")}</p>
            </TextContainer>
            <ButtonContainer>
                <Button variant="tertiary" onClick={() => onDismiss()}>
                    {translate("Select a different quantity")}
                </Button>
                <Button variant="secondary" onClick={() => onConfirm()} icon={{ position: "right", src: ChevronRight }}>
                    {translate("Confirm and continue")}
                </Button>
            </ButtonContainer>
        </>
    );
};

export default ConfirmQuantityForm;
